import React from 'react';
import { TestimonialCard } from './TestimonialCard';
const testimonials = [{
  rating: 5,
  title: 'Stubborn Sunspots!',
  text: 'Covers smoothly, easy to apply and best of all miraculously matches both the surface and undertones of my face',
  name: 'Theresa R.',
  location: 'Tampa, FL',
  imageUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
}, {
  rating: 5,
  title: 'Outstanding Product!',
  text: "I don't even need a concealer for the dark circles under my eyes. Easy to apply, great coverage and natural looking",
  name: 'Sissy H.',
  location: 'Trenton, NJ',
  imageUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop'
}, {
  rating: 5,
  title: 'Makes A Difference!',
  text: "I've never felt better about my skin. Finally something that actually works!",
  name: 'Susan M.',
  location: 'Age 64',
  imageUrl: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop'
}, {
  rating: 5,
  title: 'Worth Every Penny!',
  text: "After just two weeks, my friends are asking what I've done differently. My skin looks so much younger and healthier!",
  name: 'Patricia L.',
  location: 'Phoenix, AZ',
  imageUrl: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=100&h=100&fit=crop'
}];
export function TestimonialSidebar() {
  return <div className="space-y-6" data-id="element-340">
      {testimonials.map((testimonial, index) => <TestimonialCard key={index} {...testimonial} data-id="element-341" />)}
    </div>;
}